// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"a4824e2a","917":"c94d6fe6"}[chunkId] + ".chunk.js";
};